import type { QueryClient } from "@tanstack/react-query";
const families = new Set([
  "all-email-recipients",
  "contacts",
  "contact",
  "contacts-by-email",
  "locations-for-contact",
  "location-subscriptions",
  "store-email-recipients",
  "store-email-recipients-by-email",
  "sla-source-contact",
  "sla-deal-contact",
  "sla-location-contacts",
  "deals",
  "quotes",
  "invoices",
  "locations",
]);
const affected = (key: readonly unknown[]) =>
  families.has(String(key[0])) || String(key[0]).includes("contact");
export async function invalidateContactCaches(client: QueryClient) {
  await client.invalidateQueries({
    predicate: (query) => affected(query.queryKey),
  });
}
export function clearSessionQueries(client: QueryClient) {
  void client.cancelQueries();
  void client.resetQueries({ type: "active" });
  client.removeQueries({ type: "inactive" });
}
